import { render, staticRenderFns } from "./Wp_pdd_sku_detail_page.vue?vue&type=template&id=58e6b1fc&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./Wp_pdd_sku_detail_page.vue?vue&type=script&lang=js&"
export * from "./Wp_pdd_sku_detail_page.vue?vue&type=script&lang=js&"
import style0 from "./Wp_pdd_sku_detail_page.vue?vue&type=style&index=0&id=58e6b1fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e6b1fc",
  null
  
)

export default component.exports